import { KeyValue } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ScenarioComparisonResult, WeightedProp } from '../scenario-comparison.service';

@Component({
    selector: 'app-scenario-card',
    templateUrl: './scenario-card.component.html',
    styleUrls: ['./scenario-card.component.scss'],
    standalone: false
})
export class ScenarioCardComponent implements OnInit {

  constructor() { }

  @Input() scenarios: ScenarioComparisonResult;
  @Input() propList: WeightedProp[];

  colorClass = '';

  averageScenario = {
  };

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.scenarios && this.scenarios.scenarioData && this.scenarios.scenarioData.data) {
      this.scenarios.scenarioData.data.forEach(x => {

      });

      this.calculateMetricsIndication();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.averageScenario = {};
    this.calculateMetricsIndication();
  }

  calculateMetricsIndication() {
    if (this.scenarios && this.scenarios.scenarioData && this.scenarios.scenarioData.data) {
      this.scenarios.scenarioData.data.forEach(scenario => {
        for (const prop in scenario) {
          if (!isNaN(Number(scenario[`${prop}`])) && prop.indexOf('Id') == -1)

            if (this.averageScenario[`${prop}`]) {
              this.averageScenario[`${prop}`] += scenario[`${prop}`];
            } else {
              this.averageScenario[`${prop}`] = scenario[`${prop}`];
            }
        }
      });

      for (const prop in this.averageScenario) {
        if (!isNaN(this.averageScenario[`${prop}`]))
          if (prop == 'AvgPrice') {
            this.averageScenario[`${prop}`] = +this.averageScenario[`${prop}`].toPrecision(4) / this.scenarios.scenarioData.data.length;
          } else {
            this.averageScenario[`${prop}`] = this.averageScenario[`${prop}`] / this.scenarios.scenarioData.data.length;
          }
      }
    }
  }

  public unsorted(a: KeyValue<string, string>, b: KeyValue<string, string>) {
    return 0;
  }

  public defineDotColor(prop) {
    if (prop.value > this.averageScenario[prop.key]) {
      const propAdditional = this.propList.find(x => x.propName == prop.key);
      if (propAdditional.positiveIsGood) {
        this.colorClass = 'dot green';
      } else {
        this.colorClass = 'dot red';
      }
    } else if (prop.value < this.averageScenario[prop.key]) {
      const propAdditional = this.propList.find(x => x.propName == prop.key);
      if (!propAdditional.positiveIsGood) {
        this.colorClass = 'dot green';
      } else {
        this.colorClass = 'dot red';
      }
    } else if (prop.value == this.averageScenario[prop.key]) {
      this.colorClass = 'dot grey';
    } else {
      this.colorClass = '';
    }

    return true;
  }
}
